import { getUserEditorPreference, UserEditorPreference } from "client_legacy/Documents/officeDocumentsOpenPreference";
import { DocumentEvent, subscribe, unsubscribe } from "client_legacy/Documents/events";
import { useEffect, useState } from "react";

export function useEditorPreference(): UserEditorPreference {
	const [preference, setPreference] = useState<UserEditorPreference>(
		() => getUserEditorPreference()
	);

	useEffect(
		() => {
			const token = subscribe(
				DocumentEvent.PreferenceChanged,
				() => {
					setPreference(getUserEditorPreference());
				}
			);

			return () => unsubscribe(token);
		},
		[]
	);

	return preference;
}